import { Action, Reducer } from 'redux'
import { IDriverLocation } from 'types/Location'
import { PATH_ACTION_TYPES } from '../actions/path'

const { PATH_FAILURE, PATH_REQUEST, PATH_SUCCESS } = PATH_ACTION_TYPES

export interface IPathState {
  path: IDriverLocation[]
  loading: boolean
  error?: string
}

interface IErrorAction extends Action<string> {
  error: string
}

interface ISuccessAction extends Action<string> {
  payload: {
    path: IDriverLocation[]
  }
}

type PathAction = Action<string> | IErrorAction | ISuccessAction

const defaultState = {
  loading: false,
  path: [],
} as IPathState

const pathReducer: Reducer<IPathState, PathAction> = (state = defaultState, action) => {
  switch (action.type) {
    case PATH_REQUEST: {
      return {
        ...state,
        loading: true,
      }
    }
    case PATH_SUCCESS: {
      const {
        payload: { path },
      } = action as ISuccessAction
      return {
        ...state,
        loading: false,
        path,
      }
    }
    case PATH_FAILURE: {
      return {
        ...state,
        loading: false,
        error: (action as IErrorAction).error,
      }
    }
    default:
      return state
  }
}

export default pathReducer
